import { takeEvery } from 'redux-saga/effects';

import getDaysSaga, { action as getDaysSagaAction } from './getDaysSaga';

export default () => {
  return function* () {
    yield takeEvery(getDaysSagaAction, getDaysSaga);
  }
}
